import { render, staticRenderFns } from "./GlassMapping.vue?vue&type=template&id=22a583a6&"
import script from "./GlassMapping.vue?vue&type=script&lang=js&"
export * from "./GlassMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports